module.exports = __webpack_public_path__ + "static/media/sc-logo.f48668a7.png";